import React, { useEffect, useRef, useState, FC } from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';

//Components
import ActivityLoading from '../common/ActivityLoading';
import ActivityModal from '../common/ActivityModal';
import ActivityToast from '../common/ActivityToast';
import CountDownTimer from './components/CountDownTimer';

//Services
import firebaseService from '../../firebase/FirebaseService';
import { getLoggedUser } from '../../services/UserService';
import { getActivityById } from '../../services/ActivityService';
import { getJunctionByStudentAndActivity, addActivityToUser, removeActivityFromUser } from '../../services/NewGroupService';

//Types
import { ModalOptionsInterface, ToastOptionsInterface } from '../common/Types';

const ActivityDetails: FC = (props: any) => {
    const { location, admin } = props;

    const [loading, setLoading] = useState(false);
    const [activity, setActivity] = useState<any>({});
    const [user, setUser] = useState<any>(undefined);
    const [timeoutId, setTimeoutId] = useState<any>(undefined);
    const [modal, setModal] = useState<ModalOptionsInterface>({ open: false, header: "", body: "", buttons: [] });
    const [toastOptions, setToastOptions] = useState<ToastOptionsInterface>({ open: false, message: "" });

    const history = useHistory();
    let ref = useRef<any>(null);

    useEffect(() => {
        activitiesListener();
    }, []);

    useEffect(() => {
        return () => {
            const { activity, user, timeoutId } = ref.current;

            clearTimeout(timeoutId);
            if (location.state?.reserve) {
                getActivityById(activity.id, user.email).then((response: any) => {
                    firebaseService.updateActivity(activity.id, { reserved: response.reserved - 1 });
                })
            }
        }
    }, [location])

    const activitiesListener = () => {
        firebaseService.db?.collection("activities")
            .onSnapshot((snapshot) => {
                snapshot.docChanges().forEach(async (change) => {
                    const { activity, user } = ref.current;

                    if (change.type === "modified") {
                        if (activity.id === change.doc.id) {
                            const act = { ...activity };

                            act.reserved = change.doc.data().reserved;
                            act.inscribed = change.doc.data().inscribed;

                            const junction = await getJunctionByStudentAndActivity(user.email, change.doc.id);
                            act.subscribed = junction !== undefined;

                            setActivity(act);
                        }
                    }
                });
            });
    }

    useEffect(() => {
        ref.current = { activity, user, timeoutId };
    }, [activity, user, timeoutId])

    useEffect(() => {
        setLoading(true);

        const locationSplit = location.pathname.split('/');

        getLoggedUser().then((userResp: any) => {
            if (userResp && userResp.email) {
                setUser(userResp);

                getActivityById(locationSplit[2], userResp.email).then((response: any) => {
                    setActivity(response);
                    setLoading(false);

                    if (location.state?.reserve) {
                        firebaseService.updateActivity(response.id, { reserved: response.reserved + 1 });

                        const timeout = setTimeout(() => {
                            // goBack(response.id, userResp.email);
                            if (location.state?.reserve) {
                                getActivityById(response.id, userResp.email).then((response: any) => {
                                    firebaseService.updateActivity(response.id, { reserved: response.reserved - 1 });
                                })
                            }
                            history.goBack();
                        }, 120000);
                        setTimeoutId(timeout);
                    }
                })
            } else {
                setActivity({});
                setLoading(false);
            }
        });
    }, [location, history])

    const handleInscription = (activity: any, type: string) => {
        if (type === "subscribe") {
            setModal({
                open: true,
                header: "Register",
                body: "Before you register, make sure you have read all the available information and the schedules of your activity. Are you sure you want to register to this activity?",
                buttons: [
                    { text: "Register", func: () => saveInscription(activity, type) },
                    { text: "Cancel", func: handleModalClose }
                ]
            });
        } else {
            setModal({
                open: true,
                header: "Unregister",
                body: "Are you sure you want to unregister from this activity?",
                buttons: [
                    { text: "Unregister", func: () => saveInscription(activity, type) },
                    { text: "Cancel", func: handleModalClose }
                ]
            });
        }
    }

    const saveInscription = (activity: any, type: string) => {
        setLoading(true);

        if (activity && user?.email) {
            if (type === "subscribe") {
                addActivityToUser(user.email, activity.id).then((response) => {
                    handleModalClose();
                    if (response.code === "success") {
                        goBack(activity.id, user.email);
                    } else if (response.code === "full_group") {
                        setToastOptions({ open: true, message: response.message });
                        setLoading(false);
                    }
                })
            } else {
                removeActivityFromUser(user.email, activity.id).then(() => {
                    handleModalClose();
                    history.goBack();
                })
            }
        }
    }

    const handleModalClose = () => {
        setModal({ open: false, header: "", body: "", buttons: [] });
    }

    const goBack = (activityId: any, userId: any) => {
        if (location.state?.reserve) {
            getActivityById(activityId, userId).then((response: any) => {
                firebaseService.updateActivity(activityId, { reserved: response.reserved - 1 });
            })
        }
        history.goBack();
    }

    const handleReturn = () => {
        clearTimeout(timeoutId);
        goBack(activity.id, user.email)
    }

    if (loading)
        return <ActivityLoading />
 
    return (
        <Container>
            <ActivityModal {...modal} onClose={handleModalClose} />
            <ActivityToast {...toastOptions} onClose={() => setToastOptions({ open: false, message: "" })} autohide={4000} />
            <div style={{ marginBottom: '20px' }}>
                <h6 style={{ fontSize: '22px', lineHeight: '1', paddingTop: '30px' }}>{'Details:'}</h6>
                <h1 style={{ lineHeight: '1' }}>{activity.name}</h1>
            </div>
            <div>
                <hr></hr>
            </div>
            <Button
                type="submit"
                variant="outline-primary"
                aria-label="save"
                className="return-button"
                onClick={() => handleReturn()}
                style={{ marginTop: '7px' }}
            >
                {`Return`}
            </Button>
            <Row>
                <Col>
                    <img className="details-image" src={activity.image_url ? activity.image_url : "../cccr-default.jpg"} alt=""></img>
                </Col>
                <Col>
                    {
                    activity.inscribed >= activity.students_limit ? null :
                    !activity.subscribed ?
                    
                    <div style={{ display: 'flex', flexDirection: 'row', paddingTop: '20px', fontSize: '20px' }}> 
                        <p>Time left to enroll:</p>
                        <div style={{ marginLeft: '5px', color: 'red' }}>
                            <CountDownTimer minutes={2} seconds={0} />
                        </div>
                    </div> 
                   : null 
                    }
                    <p style={{ margin: "10px 0", color: '#212c56', fontWeight: 'bolder', fontSize: '20px' }}>{`Registered: ${activity.inscribed}/${activity.students_limit}`}</p>
                </Col>
            </Row>
            <Row>
                {activity.nameContact ?
                    <>
                        <p style={{ margin: "20px 0 10px", fontWeight: "bold", fontSize: '22px' }}>In charge:</p>
                        <p style={{ margin: "10px 0" }}>{activity.nameContact}</p>
                    </>
                    :
                    null}
                {activity.longDescription ?
                    <>
                        <p style={{ margin: "10px 0", fontWeight: "bold", fontSize: '22px' }}>Description:</p>
                        <p style={{ margin: "10px 0" }}>{activity.longDescription}</p>
                    </>
                    :
                    null}
                {activity.schedule && activity.schedule.length !== 0 ?
                    <>
                        <p style={{ margin: "10px 0", fontWeight: "bold", fontSize: '22px' }}>Schedule:</p>
                        {activity.schedule?.map((sch: string, idx: number) =>
                            <p key={idx} style={{ margin: "10px 0" }}>{sch}</p>
                        )}
                    </>
                    :
                    null}
                {activity.specific_instructions ?
                    <>
                        <p style={{ margin: "10px 0", fontWeight: "bold", fontSize: '22px' }}>Specific instructions:</p>
                        <p style={{ margin: "10px 0" }}>{activity.specific_instructions}</p>
                    </>
                    :
                    null}
                {activity.nameLocation && activity.descriptionLocation ?
                    <>
                        <p style={{ margin: "10px 0", fontWeight: "bold", fontSize: '22px' }}>Location:</p>
                        <p style={{ margin: "10px 0" }}>{activity.nameLocation}: {activity.descriptionLocation}</p>
                    </>
                    :
                    null}
                <div style={{ display: 'flex', flexDirection: 'row', margin: '10px 0px', alignItems: 'center' }}>
                    {
                    activity.subscribed ?
                    <Button variant="primary" onClick={() => handleInscription(activity, "unsubscribe")} style={{ width: '150px', marginTop: '10px', marginBottom: "20px" }} >Unregister</Button> 
                    :                        
                    activity.inscribed < activity.students_limit || admin ?
                        <Button variant="primary" onClick={() => handleInscription(activity, "subscribe")} style={{ width: '150px', marginTop: '10px', marginBottom: "20px" }} >Register</Button> 
                    :
                    activity.inscribed > activity.students_limit ? null : null
                    }
                </div>
            </Row>
        </Container>
    )
}

export default ActivityDetails;
